@let _kacheln = darstellung() === 'kacheln';
<div [class.karte]="!_kacheln" [class.kachel-block]="_kacheln">
  <div class="kopf">
    <p class="titel" [class.mat-title-small]="!_kacheln" [class.mat-title-medium]="_kacheln">{{ titel() }}</p>
    @if (einleitung(); as einleitung) {
      <p class="muted" [class.mat-body-small]="!_kacheln" [class.mat-body-medium]="_kacheln">{{ einleitung }}</p>
    }
  </div>

  @if (fragen()) {
    <form class="frage" (submit)="frageStellen($event)">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Beschreib kurz, was nicht klappt</mat-label>
        <input matInput name="frage" [(ngModel)]="frage" autocomplete="off" />
        <button type="submit" matIconButton matSuffix [disabled]="!frage().trim()" matTooltip="Support fragen" aria-label="Support fragen">
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <mat-hint>Unser KI-Assistent sieht sich die Stelle an und antwortet meist sofort.</mat-hint>
      </mat-form-field>
    </form>
    <p class="mat-label-medium muted oder">Oder direkt</p>
  }

  @if (_kacheln) {
    <!-- Zwei Kacheln nebeneinander (Canvas „Support-Einstieg“, Richtung A). Nummer und Adresse bleiben
         sichtbar und kopierbar, wie in der Karte. -->
    <div class="kacheln">
      <div class="kachel">
        <div class="kachel-kopf">
          <mat-icon>call</mat-icon>
          <lib-copy-button [content]="telefon" [small]="true" />
        </div>
        <span class="mat-label-large">Anrufen</span>
        <a class="mat-body-medium" [href]="telefonLink">{{ telefon }}</a>
        <span class="mat-body-small muted">{{ erreichbarkeit }}</span>
      </div>
      <div class="kachel">
        <div class="kachel-kopf">
          <mat-icon>mail</mat-icon>
          <lib-copy-button [content]="email" [small]="true" />
        </div>
        <span class="mat-label-large">E-Mail</span>
        <a class="mat-body-medium" [href]="mailto()">{{ email }}</a>
        <span class="mat-body-small muted">{{ antwortzeit }}</span>
      </div>
    </div>
  } @else {
    <div class="wege">
      <div class="weg">
        <mat-icon>call</mat-icon>
        <div class="wert">
          <a class="mat-body-large" [href]="telefonLink">{{ telefon }}</a>
          <p class="mat-body-small muted">{{ erreichbarkeit }}</p>
        </div>
        <lib-copy-button [content]="telefon" [small]="true" />
      </div>

      <div class="weg">
        <mat-icon>mail</mat-icon>
        <div class="wert">
          <a class="mat-body-large" [href]="mailto()">{{ email }}</a>
          <p class="mat-body-small muted">{{ antwortzeit }}</p>
        </div>
        <lib-copy-button [content]="email" [small]="true" />
      </div>
    </div>
  }
</div>
